import { PillVariantType } from '../../../../../components/pill/types/pillVariantType';
import { getDropdownStyles } from './variantStyles/dropdown';
import { getRegularStyles } from './variantStyles/regular';
import { getRoundedStyles } from './variantStyles/rounded';
import { getPillSegmentedControlStyles } from './variantStyles/segmentedControl';
export const getPillStyles = (FOUNDATIONS, FONT) => {
    return {
        [PillVariantType.REGULAR]: getRegularStyles(FOUNDATIONS, FONT),
        [PillVariantType.ROUNDED]: getRoundedStyles(FOUNDATIONS, FONT),
        [PillVariantType.DROPDOWN]: getDropdownStyles(FOUNDATIONS, FONT),
        [PillVariantType.SEGMENTED_CONTROL]: getPillSegmentedControlStyles(FOUNDATIONS, FONT),
    };
};
//# sourceMappingURL=styles.js.map